import styled from 'styled-components'

export const Field = styled.input`
  box-shadow: ${({ isRequiredError }) =>
    isRequiredError && '0 0 0.15rem 0.05rem red'};
  &:focus {
    outline: none;
    box-shadow: ${({ isRequiredError }) =>
      isRequiredError && '0 0 0.3rem 0.1rem red'};
  }
  flex: 1;
  width: 100%;

  margin-left: 0.3rem;
  margin-right: 0.3rem;

  & > label {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 8px;
  }

  & > input, select {
    height: 48px;
    border: 1px solid #c7c9c7;
    box-sizing: border-box;
    border-radius: 4px;

    &[type='date']:invalid {
      color: #757575;
    }

    &:focus {
      outline: 2px solid #2962ff;
    }
  }
   & > select {
     cursor: pointer;
   }

`

export const ContainerButtons = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: row;
`

export const ModalAlertDueDateContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 2rem;
  gap: 1rem;
`

export const ModalAlertDueDateInfo = styled.div`
  display: flex;
  align-items: start;
  justify-content: start;
  flex-direction: column;
  gap: 1rem;
`
